import angular from 'angular';
import GmfEditFeatureComponent from 'gmf/editing/editFeatureComponent.js';
import svgLine from 'gmf/icons/line_svg';
import svgPoint from 'gmf/icons/point_svg';
import svgPolygon from 'gmf/icons/polygon_svg';
import pnList from '../pronaturalist/pronaturaList.js';

const getModuleContent = (moduleExport) => {
  if (typeof moduleExport === 'string') {
    return moduleExport;
  }
  if (moduleExport && typeof moduleExport.default === 'string') {
    return moduleExport.default;
  }
  if (typeof moduleExport === 'function') {
    const result = moduleExport();
    return typeof result === 'string' ? result : '';
  }
  return '';
};

// @ts-ignore: webpack
const customEditFeatureTemplateSourceModule = require('./editFeatureComponent.html');
const customEditFeatureTemplateSource =
  getModuleContent(customEditFeatureTemplateSourceModule) || `${customEditFeatureTemplateSourceModule || ''}`;
const customEditFeatureTemplate = customEditFeatureTemplateSource
  .replaceAll('__SVG_POINT__', svgPoint)
  .replaceAll('__SVG_LINE__', svgLine)
  .replaceAll('__SVG_POLYGON__', svgPolygon);

/**
 * Override gmf/editing/editFeatureComponent partial with a custom one.
 */
GmfEditFeatureComponent.run([
  '$templateCache',
  ($templateCache) => {
    $templateCache.put('gmf/editing/editFeatureComponent', customEditFeatureTemplate);
  },
]);

// Set a module with for the pnEditComponent.
const module = angular.module('pnEditFeature', [pnList.name]);

export default module;
